import React from "react";
import { useQuery } from "@apollo/client";
import { listConformites } from "../graphql/queries";
import ConformiteAdd from "../components/admin/conformite/add/conformiteAdd";
import { Message, Header } from "semantic-ui-react";
import DisplayLoading from "../components/common/DisplayLoading";
import DisplayError from "../components/common/DisplayError";
import { userByUserType } from "../graphql/queries";

const AdmimConformiteAddPage = () => {
  const { data, loading, error } = useQuery(listConformites, {
    fetchPolicy: "network-only",
  });

  const {
    data: userList,
    error: userListError,
    loading: userListLoading,
  } = useQuery(userByUserType, {
    variables: { userType: "ADMIN" },
    fetchPolicy: "network-only",
  });
  return (
    <>
      <DisplayLoading
        loadingMessage={loading && userListLoading}
        iconName="circle notched"
      />
      <DisplayError errorMessage={error} />
      <DisplayError errorMessage={userListError} />
      <Message>
        <Header as="h2" color="blue">
          Liste des conformités
        </Header>
      </Message>

      <ConformiteAdd data={data} userList={userList} />
    </>
  );
};

export default AdmimConformiteAddPage;
